import React from 'react';
import SlideRenderer from './SlideRenderer';
import type { PresentationSlide } from '../types';

interface Props {
  slide: PresentationSlide | null;
  blackout: boolean;
}

/** Compacte preview van de huidige slide op de telefoon van de spreker --
 * uitsluitend publieke slide-inhoud, nooit privénotities (zie SpeakerNotesPanel). */
export default function CurrentSlidePreview({ slide, blackout }: Props) {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-800 bg-slate-900" style={{ aspectRatio: '16 / 9' }}>
      <SlideRenderer slide={slide} blackout={blackout} size="preview" />
    </div>
  );
}
